import { API_CALL } from '../constants/actionTypes';
import { SPORTS_LIST } from '../constants/apiTypes';
import * as SportsApi from '../api/sports';

export function getSportCategories() {
  return {
    type: API_CALL,
    api: SPORTS_LIST,
    request: SportsApi.getSports()
  };
}
